import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home background-1 fade-in-up",
  id: "home-container"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Je suis développeur ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-mug-hot" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right middle-right clickable" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPresentationPage())),
        id: "title-home",
        class: "hide"
      }, _hoisted_4)
    ]),
    _createElementVNode("span", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPresentationPage()))
    }, _hoisted_6)
  ], 64))
}